import api, { adminApiPrefix } from './Api';
import {
  SlidingBanner,
  slidingBannerFromResponse,
  slidingBannerToUpsertRequest,
} from '../interfaces/SlidingBanner/SlidingBanner';

const slidingBannerAdminApiPrefix = `${adminApiPrefix}/sliding-banners`;

export const createSlidingBanner = async (
  slidingBanner: SlidingBanner,
): Promise<SlidingBanner> => {
  const response = await api.post(
    `${slidingBannerAdminApiPrefix}`,
    slidingBannerToUpsertRequest(slidingBanner),
  );

  return slidingBannerFromResponse(response.data?.data);
};

export const getSlidingBanners = async (): Promise<SlidingBanner[]> => {
  const response = await api.get(slidingBannerAdminApiPrefix, {
    params: { 'include-inactive': true },
  });

  return (response.data?.data ?? []).map(slidingBannerFromResponse);
};

export const getSlidingBanner = async (id: number): Promise<SlidingBanner> => {
  const response = await api.get(`${slidingBannerAdminApiPrefix}/${id}`);

  return slidingBannerFromResponse(response.data?.data);
};

export const updateSlidingBanner = async (
  slidingBanner: SlidingBanner,
): Promise<SlidingBanner> => {
  const response = await api.put(
    `${slidingBannerAdminApiPrefix}/${slidingBanner.id}`,
    slidingBannerToUpsertRequest(slidingBanner),
  );

  return slidingBannerFromResponse(response.data?.data);
};

export const deleteSlidingBanner = async (id: number): Promise<void> =>
  api.delete(`${slidingBannerAdminApiPrefix}/${id}`);
